import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { CoreModule } from 'src/app/components/core/core.module';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { NgSelectModule } from '@ng-select/ng-select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PvCamRoutingModule } from './pvcam-routing.module';
import { ProgramaVerificacionService } from './pvcam.service';
import { PvCamWrapperEditComponent } from './pvcam-wrapper-edit/pvcam-wrapper-edit.component';
import { PvCamEditComponent } from './pvcam-edit/pvcam-edit.component';
import { AppModuleGlobalShared } from '../../../../app.module.global';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [PvCamWrapperEditComponent, PvCamEditComponent],
    imports: [
        ProgressSpinnerModule,
        NgbModule,
        AppModuleGlobalShared,
        SelectButtonModule,
        NgSelectModule,
        TableModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PvCamRoutingModule,
        CoreModule,
        RouterModule.forRoot([], { bindToComponentInputs: true }),
    ],
    providers: [ExceptionManager, ProgramaVerificacionService],
    exports: [],
})
export class PvCamModule {}
